import script from "./GameHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHeader.vue?vue&type=script&setup=true&lang=js"

import "./GameHeader.vue?vue&type=style&index=0&id=6a0b096e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0b096e"]])

export default __exports__